<template>
  <form id="filterSection" class="block panel--heavy">
    <h2>Filter</h2>
    <div class="form-group">
      <label for="filter-term" class="form-label ">Suchbegriff</label>
      <input class="form-control" v-model="filterTemp.term"  type="text" name="filter-term" id="filter-term" v-on:keydown.enter.prevent="$emit('set-filter', filterTemp)">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter-time">Uhrzeit ab</label>
      <select v-model="filterTemp.startTime" name="filter-time" id="filter-time">
        <option v-for="(t,i) in filterValues.startTime" :key="i" :value="t.id">{{ t.name }}</option>
      </select>
    </div>
    <ul class="modul-accordion js-accordion" :key="key">
      <li v-for="(cb,ci) in filterCheckboxes" v-if="(cb != 'weekday' || !hideWeekday)">
        <strong class="js-accordion__heading" :class="{ open: filterAccordion[cb] == true }" :aria-expanded="`${filterAccordion[cb]}`" :tabindex="0" role="button" v-on:keyup.enter="toggleAccordion(cb)"  @click="toggleAccordion(cb)">{{ filterNames[cb]}}</strong>
        <div class="js-accordion__panel" :class="{ opened: filterAccordion[cb] == true }" :aria-hidden="!filterAccordion[cb]">
            <div class="form-check" v-for="(c, cbi) in filterValues[cb]">
                <label class="form-check-label" :class="`filter-checkbox--${cb}`" :for="`${cb}${c.id}`" >
                  <input class="form-check-input" v-model="filterTemp[cb]" type="checkbox" :value="c.id" :name="`${cb}${c.id}`" :tabindex="(filterAccordion[cb] == true) ? 0 : -1" :id="`${cb}${c.id}`" >
                  {{ c.name }}
                </label>
            </div>
        </div>
      </li>
    </ul>
    <div class="form-actions">
      <div class="form-actions__left"   v-if="anyFiltersSet">
        <button type="submit" class="button button--light" @click="$emit('reset-filter')" tabindex="0" >Zurücksetzen</button>
      </div>
      <div class="form-actions__right">
        <a class="button" @click="$emit('set-filter', filterTemp)" tabindex="0" @keyup.enter="$emit('set-filter', filterTemp)" >Filter anwenden</a>
      </div>
    </div>
    <div id="filterEnd"></div>
  </form>
</template>

<script>
export default {
  props: {
    filterValues: {
      type: Object
    },
    filter: {
      type: Object
    },
    anyFiltersSet: {
      type: Boolean,
      default: false
    },
    hideWeekday: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      filterCheckboxes: ['category', 'weekday', 'eventType', 'district', 'audience', 'accessibility'],
      filterNames: {
        'category': 'Bewegungsart',
        'weekday': 'Wochentage',
        'eventType': 'Bewegungswelt',
        'district': 'Stadtbezirk',
        'audience': 'Zielgruppe',
        'accessibility': "Barrierefreiheit"
      },
      filterAccordion: {
        'category': false, 'weekday': false, 'eventType': false, 'district': false, 'audience': false, 'accessibility': false
      },
      tabStart: 4000,
      key: 0,
      filterTemp: {
        term: '',
        startTime: null,
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        accessibility: []
      },
    }
  },
  methods: {
    toggleAccordion(mode){
      if (this.filterAccordion[mode] == true){
        this.filterAccordion[mode] = false
      }else{
        this.filterAccordion[mode] = true
      }
      this.key++
    },
    setCurrentFilter(val){
      this.filterTemp = val
      this.$emit('set-filter', this.filterTemp)
    }
  }
}
</script>

<style>
.js-accordion .js-accordion__panel { height: 0px; }
.js-accordion .js-accordion__panel.opened { height: auto; display: block; }
</style>
